'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var dagPB = require('ipld-dag-pb');

var DAGNode = dagPB.DAGNode;
var DAGLink = dagPB.DAGLink;

var mh = require('multihashes');

var multicodec = require('multicodec');

function parseBuffer(buf, encoding) {
  switch (encoding) {
    case 'json':
      return parseJSONBuffer(buf);

    case 'protobuf':
      return parseProtoBuffer(buf);

    default:
      throw new Error("unkown encoding: ".concat(encoding));
  }
}

function parseJSONBuffer(buf) {
  var data;
  var links;

  try {
    var parsed = JSON.parse(buf.toString());
    links = (parsed.Links || []).map(function (link) {
      return new DAGLink(link.Name || link.name, link.Size || link.size, mh.fromB58String(link.Hash || link.hash || link.multihash));
    });
    data = Buffer.from(parsed.Data);
  } catch (err) {
    throw new Error('failed to parse JSON: ' + err);
  }

  return new DAGNode(data, links);
}

function parseProtoBuffer(buf) {
  return dagPB.util.deserialize(buf);
}

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      gcLock = _ref.gcLock,
      preload = _ref.preload;
  return /*#__PURE__*/function () {
    var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj, options) {
      var encoding, node, release, cid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              encoding = options.enc;

              if (!Buffer.isBuffer(obj)) {
                _context.next = 12;
                break;
              }

              if (!encoding) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return parseBuffer(obj, encoding);

            case 6:
              node = _context.sent;
              _context.next = 10;
              break;

            case 9:
              node = new DAGNode(obj);

            case 10:
              _context.next = 21;
              break;

            case 12:
              if (!DAGNode.isDAGNode(obj)) {
                _context.next = 16;
                break;
              }

              // already a dag node
              node = obj;
              _context.next = 21;
              break;

            case 16:
              if (!(typeof obj === 'object')) {
                _context.next = 20;
                break;
              }

              node = new DAGNode(obj.Data, obj.Links);
              _context.next = 21;
              break;

            case 20:
              throw new Error('obj not recognized');

            case 21:
              _context.next = 23;
              return gcLock.readLock();

            case 23:
              release = _context.sent;
              _context.prev = 24;
              _context.next = 27;
              return ipld.put(node, multicodec.DAG_PB, {
                cidVersion: 0,
                hashAlg: multicodec.SHA2_256
              });

            case 27:
              cid = _context.sent;

              if (options.preload !== false) {
                preload(cid);
              }

              return _context.abrupt("return", cid);

            case 30:
              _context.prev = 30;
              release();
              return _context.finish(30);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[24,, 30, 33]]);
    }));

    function put(_x, _x2) {
      return _put.apply(this, arguments);
    }

    return put;
  }();
};